import axios from "axios";
import { API_PATHS } from "../utils/constants/api.constants";

class DirectorsService {
   

    static ListDirectors(item) {
        const api = `${API_PATHS.directorslist}`;
        const formData = new FormData();
    
        for (const key in item) {
          if (item.hasOwnProperty(key)) {
            formData.append(key, item[key]);
          }
        }
    
        return axios
          .post(api, formData, {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
            },
          })
          .then((response) => response.data);
      }

      static AddDirector(item) {
        const api = `${API_PATHS.directorsStore}`;
        const payload = item instanceof FormData ? item : new FormData();

        if (!(item instanceof FormData)) {
          for (const key in item) {
            if (item.hasOwnProperty(key)) {
              payload.append(key, item[key]);
            }
          }
        }

        return axios
        .post(api, payload, {
            headers: {
                "Content-Type": "multipart/form-data"
            },
        })
        .then((response) => response.data);
    }

    static EditDirectors(item) {
      const api = `${API_PATHS.directorsEdit}`;
      const formData = new FormData();
  
      for (const key in item) {
        if (item.hasOwnProperty(key)) {
          formData.append(key, item[key]);
        }
      }
  
      return axios
        .post(api, formData, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        })
        .then((response) => response.data);
    }


      static UpdateDirector(item) {

        const api = `${API_PATHS.directorsUpdate}`;
        const payload = item instanceof FormData ? item : new FormData();

        if (!(item instanceof FormData)) {
          for (const key in item) {
            if (item.hasOwnProperty(key)) {
              payload.append(key, item[key]);
            }
          }
        }

        return axios
        .post(api, payload, {
            headers: {
                "Content-Type": "multipart/form-data"
            },
        })
        .then((response) => response.data);
  }

  static DirectorsDelete(item) {
    const api = `${API_PATHS.directorsdelete}`;
    const formData = new FormData();

    for (const key in item) {
      if (item.hasOwnProperty(key)) {
        formData.append(key, item[key]);
      }
    }

    return axios
      .post(api, formData, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      })
      .then((response) => response.data);
  }

}

export default DirectorsService;